module.exports = "/_next/static/pages/partners/52c39fb9cc5d418733215f9e88e79c06.jpg";